import { render, staticRenderFns } from "./problem-verify.vue?vue&type=template&id=02fd52e3&"
import script from "./problem-verify.vue?vue&type=script&lang=js&"
export * from "./problem-verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports